import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  GuardResult,
  CanActivateFn,
} from '@angular/router';
import { ClientUserService } from 'src/app/services';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<GuardResult> => {
  const router = inject(Router);
  const userService = inject(ClientUserService);

  try {
    const loggedIn = await userService.isLoggedIn();
    const clientIds = await userService.initTenantId();

    if (loggedIn && clientIds.tenantId) {
      return true;
    }

    if (loggedIn) {
      await userService.logout();
    }
  } catch (ex) {
    // ignore
  }

  return router.createUrlTree(['/', 'login']);
};
